<template>
    <form
        v-if="!unavailableAtPharmacyPoint && !isRefundable"
        :action="addToCartUrl"
        :class="`product_addtocart_form_${id}`"
        enctype="multipart/form-data"
    >
        <input name="form_key" type="hidden" :value="formKey" />
        <input type="hidden" name="product" :value="id" />
        <input type="hidden" name="listCategory" :value="gaListValue" />
        <span class="price-label">
            <span class="price">{{ formattedPrice }} zł</span>
        </span>

        <button
            type="button"
            class="product-item__btn"
            data-vue-init="add-to-cart"
            @click="addToCart"
        >
            Dodaj do koszyka
            <span class="sr-only">Dodaj do koszyka {{ name }}</span>
            <span class="icon icon-cart" aria-hidden="true"></span>
        </button>
    </form>
    <div v-else-if="unavailableAtPharmacyPoint">
        <button
            type="button"
            class="product-item__btn unavailable"
            :data-product-id="id"
            data-vue-init="product-out"
            @click="productOutModal(id)"
        >
            Powiadom o dostępności
        </button>
    </div>
    <div v-else>
        <a :href="url" class="btn btn-search product-item__btn">
            <span class="input-group">
                <span class="label">
                    <strong> {{ i18n('Check price') }} </strong>
                </span>
                <span
                    v-if="isAvailable || price <= 0 || isRefundable"
                    class="input-group-btn"
                >
                    <SearchIcon
                        class="icon icon-cart icon--inline"
                        width="25"
                        height="25"
                    />
                </span>
            </span>
        </a>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import SearchIcon from '@icons/search3.svg'

export default {
    scopeName: 'productout',
    name: 'ProductItemForm',
    components: {
        SearchIcon
    },
    inheritAttrs: false,
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        sku: {
            type: [String, Number],
            required: true
        },
        name: {
            type: String,
            required: true
        },
        price: {
            type: [String, Number],
            required: true
        },
        isRx: {
            type: Boolean,
            required: true
        },
        isRefundable: {
            type: Boolean,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        isAvailable: {
            type: Boolean,
            default: true
        },
        unavailableAtPharmacyPoint: {
            type: Boolean,
            default: false
        },
        gaListValue: {
            type: String,
            default: 'Catalog Page'
        }
    },
    data() {
        return {
            tooltipTitle: ' ',
            originalTooltip: null
        }
    },
    computed: {
        ...mapState({
            formKey: ({ formkey }) => formkey,
            addToCartUrl: ({ options }) => options?.addToCart?.url,
            category: ({ options }) => options?.category
        }),
        ...mapGetters(['maxPriceInfo', 'i18n']),
        formattedPrice() {
            return this.price.replace('.', ',')
        }
    },
    methods: {
        addToCart(event) {
            if (typeof $apteline !== 'undefined' && event.currentTarget) {
                this.$apteline.cart.AddToCart(event.currentTarget)
            }
        },
        productOutModal(id) {
            if (typeof $apteline !== 'undefined') {
                this.$apteline.productout.OpenProductOutModal(id)
            }
        }
    }
}
</script>
<style lang="scss">
.btn-search.product-item {
    &__btn {
        .input-group-btn {
            padding-top: 1px;
        }

        .icon {
            margin-right: 2px;
        }

        &:hover {
            path {
                fill: $white;
            }
        }

        path {
            fill: $dark-green;
        }
    }
}
</style>
